import { useEffect, useRef, useState } from 'react';

// A visitor's reveal choice is local UI state, never an access credential.
export function useGateReveal({ hasAccess, isLoading, requiresReveal, revealScope }) {
    const [revealedScope, setRevealedScope] = useState(null);
    const clickedScope = useRef(null);
    useEffect(() => {
        if ((!isLoading && !hasAccess) || !requiresReveal) {
            clickedScope.current = null;
            setRevealedScope(null);
        }
    }, [hasAccess, isLoading, requiresReveal, revealScope]);
    const needsReveal = !!(hasAccess && !isLoading && requiresReveal && revealedScope !== revealScope);
    const reveal = () => {
        if (!needsReveal || !revealScope || clickedScope.current === revealScope) return false;
        clickedScope.current = revealScope;
        setRevealedScope(revealScope);
        return true;
    };
    return { needsReveal, reveal };
}
